import { InfoCircleOutlined } from "@ant-design/icons";

export default function TooltipIcon({fontSize = 15}) {
  return (
    <InfoCircleOutlined
      className="hover-icon"
      style={{
        color: '#667085',
        fontSize,
      }}
    />
  );
}
